/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import {
  EffectComposer, Outline,
  Selection,
} from '@react-three/postprocessing';
import PropTypes from 'prop-types';

import Kamino from './models/Kamino';
import Map from './models/Map';
import SedeCarabaya from './models/SedeCarabaya';
import SedeCrillon from './models/SedeCrillon';
import SedeLimaCargo from './models/SedeLimaCargo';
import SedeMallPlaza from './models/SedeMallPlaza';
import SedeSurquillo from './models/SedeSurquillo';
import HoverBuilding from './HoverBuilding';

const allPlaces = [
  {
    sede: 'Sede Crillon',
    component: (e) => <SedeCrillon status={e} />,
    positionHtml: [-25, 12, 20],
  },
  {
    sede: 'Sede Carabaya',
    component: (e) => <SedeCarabaya status={e} />,
    positionHtml: [3, 12, 22],
  },
  {
    sede: 'Sede Lima Cargo',
    component: (e) => <SedeLimaCargo status={e} />,
    positionHtml: [17, 5, 0],
  },
  {
    sede: 'Sede Mall Plaza',
    component: (e) => <SedeMallPlaza status={e} />,
    positionHtml: [23, 16, 24],
  },
  {
    sede: 'Sede Surquillo',
    component: (e) => <SedeSurquillo status={e} />,
    positionHtml: [-35, 9, 35],
  }];
function World({ themes, finalProjectActions }) {
  const printSedes = () => {
    const dataPlaces = allPlaces.map((e, indexSedes) => {
      const { sede, component, positionHtml } = e;
      const data = themes.find((_x, index) => index === indexSedes);
      return {
        sede,
        component,
        positionHtml,
        ...data,
      };
    });
    console.log(dataPlaces);
    const sedesDisabled = dataPlaces.filter((e) => e.completedTopic === false);
    const sedesActive = dataPlaces.filter((e) => e.completedTopic === true);
    const sedeFinalProject = dataPlaces[themes.length - 1];
    const sedesNone = dataPlaces.filter((e) => e.completedTopic === undefined && e.status === undefined);
    return (
      <group>
        {
          sedesNone.map((e) => (
            <mesh key={e.sede}>
              {e.component()}
            </mesh>
          ))
        }
        {
          sedesDisabled.map((e, index) => {
            if (index === 0) {
              return (
                <mesh key={e.sede}>
                  <HoverBuilding
                    component={e.component(true)}
                    nameSede={e.sede}
                    idTopic={e.idTopic}
                    status={e.completedTopic}
                    idUser={e.idUser}
                    positionHtml={e.positionHtml}
                    theme={e.name}
                  />
                </mesh>
              );
            }
            return (
              <mesh key={e.sede}>
                {e.component(e.completedTopic)}
              </mesh>
            );
          })
        }
        {
          sedesActive.map((e) => (
            <HoverBuilding
              component={e.component(e.completedTopic)}
              nameSede={e.sede}
              idTopic={e.idTopic}
              status={e.completedTopic}
              idUser={e.idUser}
              positionHtml={e.positionHtml}
              theme={e.name}
            />
          ))
        }
        <HoverBuilding
          component={sedeFinalProject.component(sedeFinalProject.status)}
          nameSede={sedeFinalProject.sede}
          status={sedeFinalProject.status}
          finalProject
          actions={finalProjectActions}
          positionHtml={sedeFinalProject.positionHtml}
          theme="Proyecto final"
        />
        ;
      </group>
    );
  };
  return (
    <group>
      <mesh position={[-20, -10, 20]}>
        <Map />
      </mesh>
      <mesh position={[51.5, -33.9, -16.4]}>
        <Kamino />
      </mesh>
      <Selection>
        <EffectComposer multisampling={8} autoClear={false}>
          <Outline visibleEdgeColor="white" blur edgeStrength={50} width={2000} />
        </EffectComposer>
        {printSedes()}
      </Selection>
    </group>
  );
}

export default World;

World.propTypes = {
  themes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.array,
  ]))).isRequired,
  finalProjectActions: PropTypes.func.isRequired,
};
